/* ============================================================
   P5 KUNSTKIEZER — wanddecoratie kiezen in 3 stappen
   1 materiaal  2 maat  3 lijst  → prijs live, één knop.
   Werkt op elk product met de opties Materiaal, Maat en Lijst
   (echte Shopify-varianten, dus echte prijzen).
   De galerij wisselt mee: een foto met alt "materiaal: <naam>"
   (of met art-print / glas / wandkleed in de bestandsnaam) hoort
   bij dat materiaal.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-p5-kunst]');
  if (!root) return;
  var cfgEl = root.querySelector('[data-pku-config]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[pku] config', e); return; }

  function $(sel) { return root.querySelector(sel); }
  function attr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function formatMoney(cents, format) {
    var f = format || '€{{amount_with_comma_separator}}';
    var n = (cents / 100);
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount_with_comma_separator';
    var s;
    switch (key) {
      case 'amount': s = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); break;
      case 'amount_no_decimals': s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); break;
      case 'amount_no_decimals_with_comma_separator': s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      default: s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]+>/g, '').trim();
  }

  /* ---------- data ---------- */
  var variants = cfg.variants || [];
  var fotos = cfg.fotos || [];
  var hoofdfoto = cfg.hoofdfoto || (fotos[0] && fotos[0].src) || '';

  function uniek(arr) { var out = []; arr.forEach(function (x) { if (x && out.indexOf(x) === -1) out.push(x); }); return out; }
  var materialen = uniek(variants.map(function (v) { return v.materiaal; }));
  function matenVoor(mat) { return uniek(variants.filter(function (v) { return v.materiaal === mat; }).map(function (v) { return v.maat; })); }
  function lijstenVoor(mat, maat) { return uniek(variants.filter(function (v) { return v.materiaal === mat && v.maat === maat; }).map(function (v) { return v.lijst; })); }
  function vind(mat, maat, lijst) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.materiaal === mat && v.maat === maat && (lijst == null || v.lijst === lijst)) return v;
    }
    return null;
  }
  function vindId(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i]; return null; }
  function laagste(list) { var p = null; list.forEach(function (v) { if (v.beschikbaar && (p == null || v.prijs < p)) p = v.prijs; }); return p; }

  var sleutel = { artprint: ['art-print', 'wooden-frame', 'acrylic-frame', 'artprint'], glasschilderij: ['-glas', 'glass'], wandkleed: ['wandkleed', 'floating-frame'] };
  function fotoVoor(mat) {
    var m = String(mat).toLowerCase();
    for (var i = 0; i < fotos.length; i++) {
      var alt = String(fotos[i].alt || '').toLowerCase().trim();
      if (alt === 'materiaal: ' + m || alt === 'materiaal:' + m) return fotos[i];
    }
    /* Op bestandsnaam: liefst de foto van dít kunstwerk (zelfde nummer als de hoofdfoto), niet de algemene materiaalfoto van de leverancier */
    var keys = sleutel[m] || [m];
    var hoofdNaam = String(hoofdfoto).split('?')[0].split('/').pop().toLowerCase();
    var prefix = (hoofdNaam.match(/^(\d{3,})-/) || [])[1] || '';
    var kandidaten = fotos.filter(function (f) {
      var naam = String(f.src || '').split('?')[0].split('/').pop().toLowerCase();
      return keys.some(function (k) { return naam.indexOf(k) !== -1; });
    });
    if (!kandidaten.length) return null;
    if (prefix) {
      for (var j = 0; j < kandidaten.length; j++) {
        var n2 = String(kandidaten[j].src || '').split('?')[0].split('/').pop().toLowerCase();
        if (n2.indexOf(prefix + '-') === 0) return kandidaten[j];
      }
      return null;
    }
    return kandidaten[0];
  }

  var uitlegMat = cfg.uitleg || {};
  function zonderLijst(lijsten) {
    for (var i = 0; i < lijsten.length; i++) if (/zonder|geen/i.test(lijsten[i])) return lijsten[i];
    return lijsten[0];
  }
  function lijstKlassen(naam) {
    var n = String(naam).toLowerCase();
    var k = [];
    if (/zonder|geen/.test(n)) k.push('pku-lijst--geen');
    if (/acryl|plexi/.test(n)) k.push('pku-lijst--acryl');
    if (/lichtblauw/.test(n)) k.push('pku-lijst--lichtblauw');
    else if (/roze/.test(n)) k.push('pku-lijst--roze');
    else if (/doorzichtig|transparant|helder/.test(n)) k.push('pku-lijst--doorzichtig');
    else if (/donkerbruin/.test(n)) k.push('pku-lijst--donkerbruin');
    else if (/bruin/.test(n)) k.push('pku-lijst--bruin');
    else if (/zwart/.test(n)) k.push('pku-lijst--zwart');
    else if (/naturel|eiken|hout/.test(n)) k.push('pku-lijst--naturel');
    else if (/off[- ]?white|wit|cr[eè]me/.test(n)) k.push('pku-lijst--offwhite');
    if (/passe/.test(n)) k.push('pku-lijst--pp');
    if (/floating/.test(n)) k.push('pku-lijst--floating');
    if (/metaal|metalen|staal/.test(n)) k.push('pku-lijst--metaal');
    return k.join(' ');
  }
  /* Lijstnaam → groep, korte naam, passe-partout ja/nee.
     "Houten lijst zwart met passe-partout" → groep "Houten lijst", basis "Houten lijst zwart", label "Zwart", pp true */
  function lijstInfo(naam) {
    var n = String(naam).toLowerCase();
    var pp = /passe/.test(n);
    var basis = String(naam).replace(/\s*[-–,]?\s*met passe[- ]?partout/i, '').trim();
    var groep, label = basis;
    if (/zonder|geen/.test(n)) { groep = ''; label = 'Zonder lijst'; }
    else if (/houten lijst/.test(n)) { groep = 'Houten lijst'; label = basis.replace(/^houten lijst\s*/i, ''); }
    else if (/acryl/.test(n)) { groep = 'Acryllijst'; label = basis.replace(/^acryl(?:lijst)?\s*/i, ''); }
    else if (/frame/.test(n)) { groep = 'Frame'; }
    else { groep = 'Lijst'; }
    if (label) label = label.charAt(0).toUpperCase() + label.slice(1);
    return { naam: naam, basis: basis, groep: groep, label: label, pp: pp };
  }

  function maatCijfers(maat) {
    var m = String(maat).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    return m ? { b: parseFloat(m[1].replace(',', '.')), h: parseFloat(m[2].replace(',', '.')) } : null;
  }

  /* ---------- elementen ---------- */
  var el = {
    mat: $('[data-pku-mat]'), matWaarde: $('[data-pku-mat-waarde]'), matUitleg: $('[data-pku-mat-uitleg]'),
    maat: $('[data-pku-maat]'), maatWaarde: $('[data-pku-maat-waarde]'),
    lijstBlok: $('[data-pku-lijstblok]'), lijst: $('[data-pku-lijst]'), lijstWaarde: $('[data-pku-lijst-waarde]'), lijstUitleg: $('[data-pku-lijst-uitleg]'),
    variantId: $('[data-pku-variant-id]') || document.getElementById('p5p-variant-id'),
    prijs: document.getElementById('p5p-price'),
    atc: document.getElementById('p5p-atc'),
    form: document.getElementById('p5p-form'),
    sam: $('[data-pbp-samenvatting]'), samStof: $('[data-pbp-sam-stof]'), samRegel: $('[data-pbp-sam-regel]'), samPrijs: $('[data-pbp-sam-prijs]'),
    balk: $('[data-pku-balk]'), balkPrijs: $('[data-pku-balk-prijs]'), balkSub: $('[data-pku-balk-sub]'), balkKnop: $('[data-pku-balk-knop]'),
    einde: $('[data-pku-einde]'),
    slides: Array.prototype.slice.call(document.querySelectorAll('[data-pbp-slide]')),
    thumbs: Array.prototype.slice.call(document.querySelectorAll('[data-pbp-thumb]'))
  };

  /* Stap 3 bevat groepen (elk een eigen raster), dus de container zelf is geen raster */
  if (el.lijst) { el.lijst.className = 'pku-lijstgroepen'; el.lijst.removeAttribute('role'); el.lijst.removeAttribute('aria-labelledby'); }

  /* Extra galerijfoto: het kunstwerk in de gekozen lijst, groot. Zo zie je meteen wat je kiest. */
  var voorbeeld = null;
  (function maakVoorbeeld() {
    var stage = document.getElementById('p5p-gallery-scroll');
    if (!stage || !hoofdfoto) return;
    var groot = hoofdfoto.replace(/([?&])width=\d+/, '$1width=1200');
    var slide = document.createElement('div');
    slide.className = 'p5p-gallery__slide pku-voorbeeld';
    slide.setAttribute('data-pbp-slide', '');
    slide.setAttribute('data-media-id', 'pku-voorbeeld');
    slide.setAttribute('aria-hidden', 'true');
    slide.innerHTML = '<div class="pku-voorbeeld__wand"><span class="pku-lijst" data-pku-voorbeeld-kader><span class="pku-lijst__kader" data-pku-voorbeeld-binnen><span class="pku-lijst__doek"><img src="' + attr(groot) + '" alt="Voorbeeld van je keuze" width="900" height="900" data-pku-voorbeeld-img></span></span></span></div>' +
      '<p class="pku-voorbeeld__label" data-pku-voorbeeld-label>Voorbeeld van je keuze</p>';
    var badge = stage.querySelector('[data-pbp-fotobadge]');
    stage.insertBefore(slide, badge || null);
    var thumbs = document.querySelector('[data-pbp-thumbs]');
    if (thumbs) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'p5p-thumb pku-voorbeeld__thumb';
      b.setAttribute('data-pbp-thumb', '');
      b.setAttribute('data-media-id', 'pku-voorbeeld');
      b.setAttribute('aria-label', 'Voorbeeld van je keuze');
      b.innerHTML = '<img src="' + attr(hoofdfoto) + '" width="150" height="150" alt=""><span>Jouw keuze</span>';
      thumbs.insertBefore(b, thumbs.firstChild);
    }
    voorbeeld = { slide: slide, kader: slide.querySelector('[data-pku-voorbeeld-kader]'), binnen: slide.querySelector('[data-pku-voorbeeld-binnen]'), img: slide.querySelector('[data-pku-voorbeeld-img]'), label: slide.querySelector('[data-pku-voorbeeld-label]') };
    el.slides = Array.prototype.slice.call(document.querySelectorAll('[data-pbp-slide]'));
    el.thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-pbp-thumb]'));
    el.thumbs.forEach(function (t) { t.addEventListener('click', function () { toonFoto(t.dataset.mediaId); }); });
  })();

  /* Het kunstwerk uit de foto knippen: de leveranciersfoto heeft een witte rand om het beeld.
     We meten waar het wit ophoudt, zodat de lijst strak om het kunstwerk komt. */
  var kunstBox = null; /* {x, y, w, h} als fractie van de foto, plus ratio breedte/hoogte van het beeld */
  function kunstImg(src) {
    if (!kunstBox) return '<span class="pku-lijst__doek"><img src="' + attr(src) + '" alt="" loading="lazy" decoding="async"></span>';
    var st = 'left:' + (-kunstBox.x / kunstBox.w * 100).toFixed(2) + '%;top:' + (-kunstBox.y / kunstBox.h * 100).toFixed(2) + '%;width:' + (100 / kunstBox.w).toFixed(2) + '%;height:' + (100 / kunstBox.h).toFixed(2) + '%';
    return '<span class="pku-lijst__doek"><img src="' + attr(src) + '" alt="" loading="lazy" decoding="async" style="' + st + '"></span>';
  }
  function kaderStijl() { return kunstBox ? ' style="--pku-ratio:' + kunstBox.ratio.toFixed(4) + '"' : ''; }
  (function meetKunst() {
    if (!hoofdfoto) return;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var nw = im.naturalWidth, nh = im.naturalHeight;
        if (!nw || !nh) return;
        var W = 320, H = Math.max(8, Math.round(W * nh / nw));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var ctx = c.getContext('2d'); ctx.drawImage(im, 0, 0, W, H);
        var d = ctx.getImageData(0, 0, W, H).data, x, y, i, r, g, b;
        /* Achtergrondkleur = mediaan van de buitenste rand van de foto (wit of lichtgrijs bij de leverancier) */
        var rand = [[], [], []], m = Math.max(2, Math.round(Math.min(W, H) * 0.02));
        for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
          if (x >= m && x < W - m && y >= m && y < H - m) continue;
          i = (y * W + x) * 4;
          rand[0].push(d[i]); rand[1].push(d[i + 1]); rand[2].push(d[i + 2]);
        }
        function med(a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
        var bgR = med(rand[0]), bgG = med(rand[1]), bgB = med(rand[2]);
        var bgLum = 0.299 * bgR + 0.587 * bgG + 0.114 * bgB;
        if (bgLum < 150) { kunstBox = { x: 0, y: 0, w: 1, h: 1, ratio: nw / nh }; renderMaat(); renderLijst(); update(false); return; } /* donkere sfeerfoto: niets knippen */
        /* Per rij en kolom tellen hoeveel pixels afwijken van de achtergrond ("beeld").
           Ook crème papier op wit telt zo mee. Sterk afwijkende pixels vormen het startpunt. */
        var rij = new Array(H), kol = new Array(W), sch = new Array(H);
        for (y = 0; y < H; y++) { rij[y] = 0; sch[y] = 0; }
        for (x = 0; x < W; x++) kol[x] = 0;
        var dMinX = W, dMinY = H, dMaxX = -1, dMaxY = -1, sMinX = W, sMinY = H, sMaxX = -1, sMaxY = -1;
        for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
          i = (y * W + x) * 4;
          if (d[i + 3] < 40) continue;
          r = d[i]; g = d[i + 1]; b = d[i + 2];
          var diff = Math.max(Math.abs(r - bgR), Math.abs(g - bgG), Math.abs(b - bgB));
          if (diff > 12) {
            rij[y]++; kol[x]++;
            if (x < dMinX) dMinX = x; if (x > dMaxX) dMaxX = x; if (y < dMinY) dMinY = y; if (y > dMaxY) dMaxY = y;
          }
          if (diff > 60) { if (x < sMinX) sMinX = x; if (x > sMaxX) sMaxX = x; if (y < sMinY) sMinY = y; if (y > sMaxY) sMaxY = y; }
        }
        function heleFoto() { kunstBox = { x: 0, y: 0, w: 1, h: 1, ratio: nw / nh }; renderMaat(); renderLijst(); update(false); }
        if (dMaxX <= dMinX || dMaxY <= dMinY) { heleFoto(); return; }
        var seed = (sMaxX > sMinX && sMaxY > sMinY) ? [sMinX, sMinY, sMaxX, sMaxY] : [dMinX, dMinY, dMaxX, dMaxY];
        /* Start bij het hart van het beeld en groei naar buiten zolang de rij/kolom grotendeels gevuld is */
        var bw = seed[2] - seed[0] + 1, bh = seed[3] - seed[1] + 1;
        var top = seed[1], bot = seed[3], lft = seed[0], rgt = seed[2];
        while (top > 0 && rij[top - 1] >= bw * 0.5) top--;
        while (bot < H - 1 && rij[bot + 1] >= bw * 0.5) bot++;
        while (lft > 0 && kol[lft - 1] >= bh * 0.5) lft--;
        while (rgt < W - 1 && kol[rgt + 1] >= bh * 0.5) rgt++;
        /* en krimp weer als de buitenste rij/kolom bijna leeg is (losse spikkels, schaduwrand) */
        while (top < bot && rij[top] < bw * 0.3) top++;
        while (bot > top && rij[bot] < bw * 0.3) bot--;
        while (lft < rgt && kol[lft] < bh * 0.3) lft++;
        while (rgt > lft && kol[rgt] < bh * 0.3) rgt--;
        /* De slagschaduw onder het kunstwerk: zelfde kleurbalans als de achtergrond, alleen donkerder.
           Rijen die daar vrijwel helemaal uit bestaan halen we onderaan weg (max. 12 % van de hoogte). */
        var maxStrip = Math.round((bot - top) * 0.12), gestript = 0;
        while (bot > top && gestript < maxStrip) {
          var n = 0, tot = 0;
          for (x = lft; x <= rgt; x++) {
            i = (bot * W + x) * 4; r = d[i]; g = d[i + 1]; b = d[i + 2]; tot++;
            var lum = 0.299 * r + 0.587 * g + 0.114 * b;
            var zelfdeBalans = Math.abs((r - g) - (bgR - bgG)) < 9 && Math.abs((g - b) - (bgG - bgB)) < 9;
            if (lum < bgLum - 2 && lum > bgLum - 95 && zelfdeBalans) n++;
          }
          if (n < tot * 0.85) break;
          bot--; gestript++;
        }
        if (rgt - lft < W * 0.2 || bot - top < H * 0.2) { heleFoto(); return; } /* te klein: geen kunstwerk gevonden */
        /* Veiligheidsmarge: de lijst valt een fractie over de rand van het beeld, zodat er nooit wit zichtbaar is */
        var mx = Math.max(1.5, (rgt - lft) * 0.012), my = Math.max(1.5, (bot - top) * 0.012);
        var box = { x: (lft + mx) / W, y: (top + my) / H, w: (rgt - lft + 1 - 2 * mx) / W, h: (bot - top + 1 - 2 * my) / H };
        box.ratio = (box.w * nw) / (box.h * nh);
        if (!(box.ratio > 0.3 && box.ratio < 3.5)) { heleFoto(); return; }
        kunstBox = box;
        renderMaat(); renderLijst(); update(false);
      } catch (e) { /* CORS of canvas niet beschikbaar: dan blijft de hele foto in beeld */ }
    };
    im.src = hoofdfoto.replace(/([?&])width=\d+/, '$1width=600');
  })();

  /* ---------- state ---------- */
  var state = { mat: materialen[0], maat: null, lijst: null, pp: false };
  (function init() {
    var start = el.variantId ? vindId(el.variantId.value) : null;
    if (!start) start = variants.filter(function (v) { return v.beschikbaar; })[0] || variants[0];
    if (start) { state.mat = start.materiaal; state.maat = start.maat; state.lijst = start.lijst; }
    else { state.maat = matenVoor(state.mat)[0]; state.lijst = zonderLijst(lijstenVoor(state.mat, state.maat)); }
    state.pp = state.lijst ? lijstInfo(state.lijst).pp : false;
  })();

  /* Volledige lijstnaam voor een basis, met of zonder passe-partout (als die bestaat) */
  function lijstNaamVoor(basis, pp, lijsten) {
    var metPp = null, zonderPp = null;
    lijsten.forEach(function (l) { var i = lijstInfo(l); if (i.basis === basis) { if (i.pp) metPp = l; else zonderPp = l; } });
    return (pp && metPp) ? metPp : (zonderPp || metPp);
  }

  /* ---------- render ---------- */
  function tegel(data, checked, inhoud, naam, sub, prijs) {
    return '<button type="button" class="pbp-tegel pku-tegel" role="radio" aria-checked="' + (checked ? 'true' : 'false') + '" tabindex="' + (checked ? 0 : -1) + '" data-pku-keuze="' + attr(data) + '">' +
      inhoud +
      '<span class="pbp-tegel__tekst"><span class="pbp-tegel__naam">' + attr(naam) + '</span>' +
      (sub ? '<span class="pbp-tegel__maat">' + attr(sub) + '</span>' : '') +
      '<span class="pbp-tegel__prijs">' + attr(prijs || '') + '</span></span></button>';
  }

  function renderMat() {
    el.mat.innerHTML = materialen.map(function (m) {
      var f = fotoVoor(m);
      var src = f ? f.src : hoofdfoto;
      var vanaf = laagste(variants.filter(function (v) { return v.materiaal === m; }));
      var inhoud = '<span class="pbp-tegel__icoon">' + (src ? '<img src="' + attr(src) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>';
      return tegel(m, m === state.mat, inhoud, m, '', vanaf != null ? 'vanaf ' + formatMoney(vanaf, cfg.moneyFormat) : '');
    }).join('');
    klikbaar(el.mat, function (waarde) {
      if (waarde === state.mat) return;
      state.mat = waarde;
      var maten = matenVoor(state.mat);
      state.maat = maten.indexOf(state.maat) !== -1 ? state.maat : maten[0];
      var lijsten = lijstenVoor(state.mat, state.maat);
      state.lijst = lijsten.indexOf(state.lijst) !== -1 ? state.lijst : zonderLijst(lijsten);
      renderMat(); renderMaat(); renderLijst(); update(true);
    });
  }

  function renderMaat() {
    var maten = matenVoor(state.mat);
    var maxKant = 0;
    maten.forEach(function (m) { var c = maatCijfers(m); if (c) maxKant = Math.max(maxKant, c.b, c.h); });
    el.maat.classList.toggle('is-vier', maten.length === 4);
    el.maat.innerHTML = maten.map(function (m) {
      var c = maatCijfers(m);
      var stijl = '';
      if (c && maxKant) stijl = ' style="width:' + (c.b / maxKant * 100).toFixed(1) + '%;height:' + (c.h / maxKant * 100).toFixed(1) + '%"';
      var v = vind(state.mat, m, state.lijst) || vind(state.mat, m, zonderLijst(lijstenVoor(state.mat, m)));
      var inhoud = '<span class="pku-maat"><span class="pku-maat__doek"' + stijl + '>' + (hoofdfoto ? kunstImg(hoofdfoto) : '') + '</span></span>';
      return tegel(m, m === state.maat, inhoud, m, '', v && v.beschikbaar ? formatMoney(v.prijs, cfg.moneyFormat) : '');
    }).join('');
    klikbaar(el.maat, function (waarde) {
      if (waarde === state.maat) return;
      state.maat = waarde;
      var lijsten = lijstenVoor(state.mat, state.maat);
      state.lijst = lijsten.indexOf(state.lijst) !== -1 ? state.lijst : zonderLijst(lijsten);
      renderMaat(); renderLijst(); update(false);
    });
  }

  function renderLijst() {
    var lijsten = lijstenVoor(state.mat, state.maat);
    if (lijsten.length <= 1) {
      el.lijstBlok.hidden = true;
      return;
    }
    el.lijstBlok.hidden = false;

    /* Groepen: Zonder lijst · Houten lijst · Acryllijst · Frame — passe-partout wordt één schakelaar */
    var groepen = [], perGroep = {}, gezien = {};
    lijsten.forEach(function (l) {
      var i = lijstInfo(l);
      if (gezien[i.basis]) { gezien[i.basis].heeftPp = gezien[i.basis].heeftPp || i.pp; gezien[i.basis].heeftZonderPp = gezien[i.basis].heeftZonderPp || !i.pp; return; }
      gezien[i.basis] = { basis: i.basis, label: i.label, groep: i.groep, heeftPp: i.pp, heeftZonderPp: !i.pp };
      if (!perGroep[i.groep]) { perGroep[i.groep] = []; groepen.push(i.groep); }
      perGroep[i.groep].push(gezien[i.basis]);
    });
    var huidig = lijstInfo(state.lijst || '');
    var ppMogelijk = !!(gezien[huidig.basis] && gezien[huidig.basis].heeftPp && gezien[huidig.basis].heeftZonderPp);

    var html = groepen.map(function (g) {
      var items = perGroep[g];
      var tegels = items.map(function (it) {
        var naam = lijstNaamVoor(it.basis, state.pp, lijsten);
        var v = vind(state.mat, state.maat, naam);
        var klassen = lijstKlassen(it.basis) + (state.pp && it.heeftPp ? ' pku-lijst--pp' : '');
        var inhoud = '<span class="pku-lijst ' + klassen + '"><span class="pku-lijst__kader"' + kaderStijl() + '>' + (hoofdfoto ? kunstImg(hoofdfoto) : '') + '</span></span>';
        return tegel(it.basis, it.basis === huidig.basis, inhoud, it.label, '', v && v.beschikbaar ? formatMoney(v.prijs, cfg.moneyFormat) : '');
      }).join('');
      return '<div class="pku-groep">' +
        (g ? '<span class="pku-groep__kop">' + attr(g) + '</span>' : '') +
        '<div class="pbp-tegels pku-tegels--lijst' + (items.length === 1 ? ' pku-tegels--een' : '') + '" role="radiogroup" aria-label="' + attr(g || 'Zonder lijst') + '">' + tegels + '</div></div>';
    }).join('');

    if (ppMogelijk) {
      html += '<div class="pbp-richting pku-pp" role="group" aria-label="Passe-partout">' +
        '<span class="pbp-richting__label">Passe-partout</span>' +
        '<div class="pbp-richting__knoppen" role="radiogroup" aria-label="Met of zonder passe-partout">' +
        '<button type="button" role="radio" aria-checked="' + (!state.pp) + '" tabindex="' + (state.pp ? -1 : 0) + '" data-pku-pp="0">Zonder</button>' +
        '<button type="button" role="radio" aria-checked="' + (!!state.pp) + '" tabindex="' + (state.pp ? 0 : -1) + '" data-pku-pp="1">Met</button>' +
        '</div><span class="pbp-richting__hint">Witte rand tussen het kunstwerk en de lijst</span></div>';
    }
    el.lijst.innerHTML = html;

    klikbaar(el.lijst, function (basis) {
      if (basis === lijstInfo(state.lijst || '').basis) return;
      state.lijst = lijstNaamVoor(basis, state.pp, lijsten);
      renderLijst(); renderMaat(); update(false, true);
    });
    Array.prototype.forEach.call(el.lijst.querySelectorAll('[data-pku-pp]'), function (b) {
      b.addEventListener('click', function () {
        state.pp = b.dataset.pkuPp === '1';
        state.lijst = lijstNaamVoor(lijstInfo(state.lijst || '').basis, state.pp, lijsten);
        renderLijst(); renderMaat(); update(false, true);
      });
    });
  }

  function klikbaar(groep, kies) {
    var knoppen = Array.prototype.slice.call(groep.querySelectorAll('[data-pku-keuze]'));
    knoppen.forEach(function (b, i) {
      b.addEventListener('click', function () { kies(b.dataset.pkuKeuze); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0);
        if (!d) return;
        e.preventDefault();
        var n = knoppen[(i + d + knoppen.length) % knoppen.length];
        n.focus(); kies(n.dataset.pkuKeuze);
      });
    });
  }

  /* ---------- galerij ---------- */
  function toonFoto(id) {
    if (!id) return;
    id = String(id);
    var gevonden = false;
    el.slides.forEach(function (s) { var m = s.dataset.mediaId === id; s.classList.toggle('is-active', m); s.setAttribute('aria-hidden', m ? 'false' : 'true'); if (m) gevonden = true; });
    if (!gevonden) return;
    el.thumbs.forEach(function (t) { var m = t.dataset.mediaId === id; t.classList.toggle('is-active', m); if (m) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    var bar = document.getElementById('p5p-gallery-progress-bar');
    if (bar && el.slides.length > 1) {
      var idx = el.slides.map(function (s) { return s.dataset.mediaId; }).indexOf(id);
      if (idx > -1) { bar.style.width = (100 / el.slides.length) + '%'; bar.style.left = (idx / el.slides.length * 100) + '%'; }
    }
  }

  /* ---------- samenvatting, prijs, knop ---------- */
  function update(wisselFoto, wisselLijst) {
    var v = vind(state.mat, state.maat, state.lijst);
    var lijsten = lijstenVoor(state.mat, state.maat);
    var kan = !!(v && v.beschikbaar);
    var li = state.lijst ? lijstInfo(state.lijst) : null;
    var metLijst = !!(li && li.groep && lijsten.length > 1);

    if (el.variantId && v) el.variantId.value = v.id;
    if (el.prijs) el.prijs.textContent = v ? formatMoney(v.prijs, cfg.moneyFormat) : '—';

    if (el.matWaarde) el.matWaarde.textContent = state.mat || '';
    if (el.maatWaarde) el.maatWaarde.textContent = state.maat || '';
    if (el.lijstWaarde) el.lijstWaarde.textContent = lijsten.length > 1 ? (state.lijst || '') : '';
    if (el.lijstWaarde && lijsten.length > 1 && state.lijst) { var li2 = lijstInfo(state.lijst); var kort = (li2.groep && li2.label.toLowerCase().indexOf(li2.groep.toLowerCase()) === -1) ? li2.groep + ' ' + li2.label.toLowerCase() : li2.label; el.lijstWaarde.textContent = kort + (li2.pp ? ', met passe-partout' : ''); }
    if (el.matUitleg) el.matUitleg.textContent = uitlegMat[state.mat] || '';
    if (el.lijstUitleg) el.lijstUitleg.textContent = '';

    var delen = [state.mat, state.maat];
    if (lijsten.length > 1 && state.lijst) delen.push(state.lijst);
    var regel = delen.join(' · ');

    if (el.sam) {
      el.sam.hidden = !v;
      if (el.samStof) el.samStof.style.backgroundImage = 'url("' + hoofdfoto + '")';
      if (el.samRegel) el.samRegel.textContent = regel;
      if (el.samPrijs) el.samPrijs.textContent = v ? formatMoney(v.prijs, cfg.moneyFormat) : '';
    }
    if (el.atc) {
      el.atc.disabled = !kan;
      el.atc.textContent = kan ? 'IN WINKELWAGEN' : 'UITVERKOCHT';
    }
    if (el.balkPrijs) el.balkPrijs.textContent = v ? formatMoney(v.prijs, cfg.moneyFormat) : '';
    if (el.balkSub) el.balkSub.textContent = regel;
    if (el.balkKnop) el.balkKnop.disabled = !kan;

    if (voorbeeld) {
      voorbeeld.kader.className = 'pku-lijst ' + (li ? lijstKlassen(li.basis) + (li.pp ? ' pku-lijst--pp' : '') : '');
      voorbeeld.label.textContent = metLijst ? 'Voorbeeld: ' + regel : 'Voorbeeld van je keuze';
      if (kunstBox && voorbeeld.binnen && voorbeeld.img) {
        voorbeeld.binnen.style.setProperty('--pku-ratio', kunstBox.ratio.toFixed(4));
        voorbeeld.img.style.left = (-kunstBox.x / kunstBox.w * 100).toFixed(2) + '%';
        voorbeeld.img.style.top = (-kunstBox.y / kunstBox.h * 100).toFixed(2) + '%';
        voorbeeld.img.style.width = (100 / kunstBox.w).toFixed(2) + '%';
        voorbeeld.img.style.height = (100 / kunstBox.h).toFixed(2) + '%';
      }
    }
    if (wisselFoto || wisselLijst) {
      if (metLijst && voorbeeld) { toonFoto('pku-voorbeeld'); }
      else { var foto = fotoVoor(state.mat); if (foto) toonFoto(foto.id); else if (fotos[0]) toonFoto(fotos[0].id); }
    }

    try {
      if (v && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      }
    } catch (e) { /* stil */ }
  }

  /* ---------- koopbalk op mobiel ---------- */
  if (el.balk && el.atc && 'IntersectionObserver' in window) {
    var knopZichtbaar = true, voorbijEinde = false;
    function toonBalk() {
      var zichtbaar = !knopZichtbaar && !voorbijEinde && window.innerWidth < 1024;
      el.balk.classList.toggle('is-zichtbaar', zichtbaar);
      el.balk.setAttribute('aria-hidden', zichtbaar ? 'false' : 'true');
      if (zichtbaar) el.balk.removeAttribute('inert'); else el.balk.setAttribute('inert', '');
    }
    new IntersectionObserver(function (es) { es.forEach(function (e) { knopZichtbaar = e.isIntersecting || e.boundingClientRect.top > 0; }); toonBalk(); }, { threshold: 0 }).observe(el.atc);
    if (el.einde) new IntersectionObserver(function (es) { es.forEach(function (e) { voorbijEinde = e.boundingClientRect.top < 0; }); toonBalk(); }, { threshold: 0 }).observe(el.einde);
    if (el.balkKnop) el.balkKnop.addEventListener('click', function () {
      if (el.atc.disabled) return;
      if (el.form && el.form.requestSubmit) el.form.requestSubmit(el.atc); else el.atc.click();
    });
  }

  renderMat(); renderMaat(); renderLijst(); update(true);
})();
